// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
body {
    background: #000;
    color: #eee;
    font-family: sans-serif;
    font-size: 9pt;
    padding: 0;
    margin: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
}


#loadingOverlay {
    position: absolute;
    top: 0;
    left: 0;
    opacity: .9;
    width: 100%;
    height: 100%;
    display: none
}

#loadingOverlay h1 {
    text-align: center;
    position: relative;
    top: 50%;
    margin-top: -.5em
}

.sandcastle-loading #loadingOverlay {
    display: block
}

.sandcastle-loading{
    display: none
}

.infoPanel {
    background: rgba(42,42,42,.8);
    padding: 4px;
    border: 1px solid #444;
    border-radius: 4px
}`, "",{"version":3,"sources":["webpack://./src/burnair/modules/3dViewer/bucket.css"],"names":[],"mappings":";AACA;IACI,gBAAgB;IAChB,WAAW;IACX,uBAAuB;IACvB,cAAc;IACd,UAAU;IACV,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;;AAGA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,sBAAsB;IACtB;AACJ","sourcesContent":["\nbody {\n    background: #000;\n    color: #eee;\n    font-family: sans-serif;\n    font-size: 9pt;\n    padding: 0;\n    margin: 0;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n}\n\n\n#loadingOverlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: .9;\n    width: 100%;\n    height: 100%;\n    display: none\n}\n\n#loadingOverlay h1 {\n    text-align: center;\n    position: relative;\n    top: 50%;\n    margin-top: -.5em\n}\n\n.sandcastle-loading #loadingOverlay {\n    display: block\n}\n\n.sandcastle-loading{\n    display: none\n}\n\n.infoPanel {\n    background: rgba(42,42,42,.8);\n    padding: 4px;\n    border: 1px solid #444;\n    border-radius: 4px\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
